export const Index = () => import("./IndexComponent.vue");
export const List = () => import("./List.vue");
export const Edit = () => import("./Edit.vue");
